const KnownWorlds = [
  {
    name: 'Heartoast Hedge Fund',
    imageName: 'res/toast_llc.png',
  },
];

export default KnownWorlds;
